// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35K1a","left":"styles_left__2hotX"};